import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { throwApiError } from "./apiError";
import { getTrackingHeadersMap } from "./getTrackingHeaders";

export interface ISpecialInstructionsResponse {
  specialInstructions?: string;
}

/**
 * Fetches concatenated special instructions for a customer account.
 */
export const getSpecialInstructions = async (
  customerCode: string,
  apiHeaders: Record<string, string> = {},
): Promise<ISpecialInstructionsResponse> => {
  const normalizedCustomerCode = customerCode?.trim();
  if (!normalizedCustomerCode) {
    return { specialInstructions: "" };
  }

  try {
    const headers = {
      ...getTrackingHeadersMap(ApiType.SPECIAL_INSTRUCTIONS),
      ...apiHeaders,
    };

    const url = `${getUrl(ApiType.SPECIAL_INSTRUCTIONS)}?customerCode=${encodeURIComponent(normalizedCustomerCode)}`;
    const response = await axios.get(url, { headers });
    return response.data;
  } catch (error: any) {
    return throwApiError(error, ErrorMessages.specialInstructions, {
      badRequestOrder: "errorsFirst",
    });
  }
};
